<mat-spinner class="fs-spinner" *ngIf="!load"></mat-spinner>

<div class="fs-view" [class.fs-hidden]="!load">

  <!-- Ambient radial glow -->
  <div class="fs-ambient"></div>

  <!-- Particle wave meshes -->
  <div class="fs-wave-l"></div>
  <div class="fs-wave-r"></div>

  <!-- Header bar -->
  <div class="fs-head">
    <div class="fs-logo-wrap"
         [class.logo_hide]="!isChecked"
         [class.top-left]="classToggled"
         [class.top-right]="toprightclass">
      <img src="assets/images/LTI-logo-white-v2.png"
           class="fs-logo-img" [style.width.%]="startValue" alt="LetsTimeIt">
    </div>
    <button class="fs-exit" (click)="closeScreen()" title="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content column -->
  <div class="fs-body">

    <!-- ① Speaker & title -->
    <div class="fs-top-info" [class.invisible-el]="hideTimer">
      <p class="fs-spk-title" [class.invisible-el]="!timerDetails.show_title">
        {{timerDetails.title}}
      </p>
      <p class="fs-spk-name" [class.invisible-el]="!timerDetails.show_speaker">
        {{timerDetails.speaker ?? '—'}}
      </p>
      <div class="fs-title-rule">
        <span class="fs-title-diamond">◆</span>
      </div>
    </div>

    <!-- ② Ring -->
    <div class="fs-ring-area">
      <div class="fs-ring-outer" [class.invisible-el]="hideTimer">

        <svg class="fs-ring-svg" viewBox="0 0 200 200" overflow="visible">
          <!-- Outermost dotted ring -->
          <circle cx="100" cy="100" r="98" fill="none"
            stroke="rgba(255,255,255,0.1)" stroke-width="0.8"
            stroke-dasharray="2.5 7"/>
          <!-- Outer solid ring -->
          <circle cx="100" cy="100" r="93" fill="none"
            stroke="rgba(255,255,255,0.06)" stroke-width="1"/>
          <!-- Inner ring edge -->
          <circle cx="100" cy="100" r="77" fill="none"
            stroke="rgba(255,255,255,0.05)" stroke-width="0.8"/>
        </svg>

        <!-- Gold hotspot top-right -->
        <div class="fs-ring-glow"></div>
        <!-- Cool reflection bottom-left -->
        <div class="fs-ring-cool"></div>

        <!-- Dark disc -->
        <div class="fs-disc">
          <div class="fs-inner-ring fs-ir-1"></div>
          <div class="fs-inner-ring fs-ir-2"></div>

          <div class="fs-disc-content">
            <div class="fs-time" [class.fs-overtime]="timevalue<0" [@focus]="timerState">
              {{ ("0"+(minutes<0?0:minutes)).slice(-2) }}:{{ ("0"+(seconds<0?0:seconds)).slice(-2) }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ③ Message card -->
    <div class="fs-msg-wrap" [@focus]="messageState">
      <div class="fs-msg-card">
        <div class="fs-msg-icon-box">
          <mat-icon class="fs-msg-star">auto_awesome</mat-icon>
        </div>
        <div class="fs-msg-body">
          <span class="fs-msg-lbl">MESSAGE</span>
          <p #output class="fs-msg-txt"></p>
        </div>
        <div class="fs-msg-arrow">
          <mat-icon>arrow_forward</mat-icon>
        </div>
      </div>
    </div>

  </div><!-- /.fs-body -->

  <div class="fs-blackout" [class.active]="blkOut"></div>
  <canvas id="customtimer" style="display:none">{{chart}}</canvas>

</div>
